<template>
  <b-modal
    id="confirm-to-change-vehicle"
    ref="confirm-to-change-vehicle"
    class="mc-modal"
    centered
    hide-header-close
    :title="$t('routeOptimization.modal.confirmChangeVehicle.title')"
  >
    <div class="card-body">
      <p
        class="description"
        v-html="$t('routeOptimization.alert.confirmChangeVehicle', {
          vehicle: vehicle?.license_plate + (vehicle?.hull_no ? ' ' + vehicle.hull_no : '')
        })"
      />
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 justify-content-end">
        <McButton
          class="me-2"
          variant="secondary"
          :text="$t('global.action.cancel')"
          @click="handleClose(cancel)"
        />
        <McButton
          variant="primary"
          :text="$t('global.action.apply')"
          @click="handleConfirmChangeVehicle()"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

import { formatIndexDate } from '@/helpers/tzDate'

export default {
  name: 'ConfirmToChangeVehicle',
  components: {
    McButton,
  },
  props: {
    vehicle: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    formatIndexDate,
    handleClose(cancel) {
      cancel()
    },
    handleConfirmChangeVehicle() {
      this.$emit('confirmChangeVehicle')
    },
  },
}
</script>
